import React from "react";
import "./authSkeleton.css";

const Field = () => (
	<div className="sf-sk-field">
		<div className="sf-sk-label sf-sk-shimmer" />
		<div className="sf-sk-input sf-sk-shimmer" />
	</div>
);

/**
 * Loading state for the invite flows, which verify a token before they
 * can render anything. Mirrors the real page's chrome — same page wash,
 * same card — so the swap-in isn't a layout jump.
 *
 * `fields` is how many stacked inputs the real form shows and `rows` how
 * many two-up rows, so the skeleton is roughly the height of what
 * replaces it.
 */
const AuthSkeleton = ({ fields = 5, rows = 2 }) => (
	<div className="sf-auth-page is-wide sf-sk-root">
		<div className="sf-auth-shell">
			<div className="sf-auth-card" aria-busy="true">
				<div className="sf-sk-head">
					<div className="sf-sk-title sf-sk-shimmer" />
					<div className="sf-sk-sub sf-sk-shimmer" />
				</div>

				<div className="sf-sk-callout sf-sk-shimmer" />

				{Array.from({ length: rows }).map((_, i) => (
					<div className="sf-sk-row" key={`row-${i}`}>
						<Field />
						<Field />
					</div>
				))}

				{Array.from({ length: fields }).map((_, i) => (
					<Field key={`field-${i}`} />
				))}

				<div className="sf-sk-check sf-sk-shimmer" />
				<div className="sf-sk-cta sf-sk-shimmer" />
			</div>
		</div>
	</div>
);

export default AuthSkeleton;
